export const SkullIcon = () => {
  return (
    <i className='material-symbols-skull-outline min-w-[20px] min-h-[20px] m-[2px] bg-[var(--mui-palette-error-main)]' />
  );
};
